import { Injectable } from '@angular/core';
import { AddinExecute, Execute } from '@techwan/ionic-core';
import { CardsLayerService } from '../../cards-layer/cards-layer.service';
import { DrawingLayerService } from '../../drawing-layer/drawing-layer.service';
import { LayerControllerService } from '../../layer-controller/layer-controller.service';
import { PositionLayerService } from '../../position-layer/position-layer.service';

@AddinExecute({
  name: 'map-layers-controller',
  description: 'No description'
})
@Injectable()
export class MapLayersControllerService extends Execute {
  constructor(
    private layerController: LayerControllerService,
    private positionLayer: PositionLayerService,
    private drawingLayer: DrawingLayerService,
    private cardsLayer: CardsLayerService
  ) {
    super();
  }

  execute() {
    this.layerController.addController(this.positionLayer);
    this.layerController.addController(this.drawingLayer);
    this.layerController.addController(this.cardsLayer);
  }
}
